import React from 'react';

export const LoadingView = () => (
  <div className={'col-sm-12 text-center'}
       style={{
         position: 'absolute',
         top: '50%',
         left: '50%',
         transform: 'translate(-50%, -50%)'
       }}>
    <div className='spinner-grow text-primary' role='status'>
      <span className='sr-only'>Loading...</span>
    </div>
  </div>
);